const settings = {
  baseApiUrl: "https://staging-api.vaix.ai",
  // baseApiUrl: "https://api.vaix.ai",
  operator: "icap",
  vaixClientId: "icap",
  widgetSettingsType: "widget_settings",
  // widgetSettingsType: "development_widget_settings",
  excludeRecentFrom: ["recommended", "combined"],
  shuffledSwimlanes: ["trending", "favoriteStudio"],
  components: {
    sliderItem: {
      magnifyOnHover: true,
      showPlayBtnOnHover: true,
      tags: [],
    },
  },
};

export default settings;
